(function () {
  'use strict';  
  class ProductCardSwatches extends HTMLElement {
    connectedCallback() { 
      var wrap = this.closest('.product-card__media-wrap') || this.closest('.product-card') || document;
      this.primaryImg = wrap.querySelector('.product-card__img--primary');
      this.swiperEl = wrap.querySelector('[data-pc-swiper]');
      this.onOver = this.onOver.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onClick = this.onClick.bind(this);

      this.addEventListener('mouseover', this.onOver);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseover', this.onOver);
      this.removeEventListener('focusin', this.onFocus);
      this.removeEventListener('click', this.onClick);
    }

    swapTo(swatch) {
      if (!this.primaryImg || !swatch) return;
      var img = swatch.getAttribute('data-image');
      if (!img) return;
      this.primaryImg.setAttribute('src', img);
      var srcset = swatch.getAttribute('data-image-srcset');
      if (srcset) this.primaryImg.setAttribute('srcset', srcset);
      var alt = swatch.getAttribute('data-image-alt');
      if (alt != null) this.primaryImg.setAttribute('alt', alt);
    }

    closestSwatch(target) {
      return target && target.closest ? target.closest('[data-swatch]') : null;
    }

    slideToSwatch(swatch) {
      if (!this.swiperEl || !swatch) return;
      var id = swatch.getAttribute('data-media-id');
      if (!id) return;

      var sw = this.swiperEl.swiperInstance || this.swiperEl.swiper;

      
      if (!sw && window.SectionCarousel) {
        window.SectionCarousel.reinit(this.swiperEl);
        sw = this.swiperEl.swiperInstance || this.swiperEl.swiper;
      }
      if (!sw || typeof sw.slideToLoop !== 'function') return;

      var slides = this.swiperEl.querySelectorAll('.swiper-slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) {
          sw.slideToLoop(i);
          return;
        }
      }
    }

    setActive(swatch) {
      this.clearActive();
      if (swatch) swatch.classList.add('is-active');
    }

    clearActive() {
      var active = this.querySelectorAll('.product-card__swatch.is-active');
      for (var i = 0; i < active.length; i++) {
        active[i].classList.remove('is-active');
      }
    }

    onOver(event) {
      var swatch = this.closestSwatch(event.target);
      if (swatch) {
        this.swapTo(swatch);
        this.slideToSwatch(swatch);
        this.setActive(swatch);
      }
    }

    onFocus(event) {
      var swatch = this.closestSwatch(event.target);
      if (swatch) {
        this.swapTo(swatch);
        this.slideToSwatch(swatch);
        this.setActive(swatch);
      }
    }

    onClick(event) {
      var toggle = event.target && event.target.closest
        ? event.target.closest('[data-swatch-toggle]')
        : null;
      if (toggle) {
        event.preventDefault();
        this.toggleExtras(toggle);
        return;
      }

      var swatch = this.closestSwatch(event.target);
      if (!swatch) return;
      var selected = this.querySelector('.product-card__swatch.is-selected');
      if (selected) selected.classList.remove('is-selected');
      swatch.classList.add('is-selected'); 
    }

    toggleExtras(toggle) {
      var expanded = this.classList.toggle('is-expanded');
      var extras = this.querySelectorAll('.product-card__swatch.is-extra');
      for (var i = 0; i < extras.length; i++) {
        if (expanded) {
          extras[i].removeAttribute('hidden');
        } else {
          extras[i].setAttribute('hidden', '');
        }
      }
 
      var more = toggle.querySelector('.product-card__swatch-toggle-icon--more');
      var less = toggle.querySelector('.product-card__swatch-toggle-icon--less');
      if (more && less) {
        if (expanded) {
          more.setAttribute('hidden', '');
          less.removeAttribute('hidden');
        } else {
          more.removeAttribute('hidden');
          less.setAttribute('hidden', '');
        }
      }

      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = expanded ? 'Show less' : 'Show more';
      toggle.setAttribute('aria-label', label);
    }
  }

  if (!customElements.get('product-card-swatches')) {
    customElements.define('product-card-swatches', ProductCardSwatches);
  }
})();
